import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import FilterField from './FilterField';

const FilterRow = ({ columns, handleFilterChange, filterPosition }) => {
  return (
    <TableRow>
      {columns.map(
        (headCol) =>
          headCol.name !== '#' && (
            <TableCell
              size="small"
              align={filterPosition ? 'left' : 'center'}
              key={headCol.id}
            >
              {headCol.name !== '#' &&
                headCol.name !== 'Измена' &&
                headCol.name !== 'Брисање' &&
                headCol.name !== 'Преглед' &&
                headCol.name !== 'Извештај' &&
                headCol.name !== 'Деактивација' &&
                headCol.name !== 'Активација' &&
                headCol.name !== 'Преузми excel' &&
                headCol.name !== 'status' &&
                headCol.name !== 'View Details' &&
                headCol.name !== 'Aktivacija / Deaktivacija' &&
                headCol.name !== 'Izmena' &&
                headCol.name !== 'Preuzmi' && (
                  <FilterField
                    headCol={headCol}
                    handleFilterChange={handleFilterChange}
                  ></FilterField>
                )}
            </TableCell>
          )
      )}
    </TableRow>
  );
};

export default FilterRow;
